import React, { useState } from "react";
import { Drawer, Stack, Title, Button, Flex, TextInput, Group } from "@mantine/core";
import { IconPlus, IconSearch, IconUsers } from "@tabler/icons-react";
import UsersTable from "./UsersTable";
import AddUserModal from "./AddUserModal";
import { useQuery } from "react-query";
import { getDepartmentUsers } from "api";

const UserManagementDrawer = ({
  opened,
  onClose,
  departmentName,
  departmentId,
  orgId,
}) => {
  const [addUserModalOpened, setAddUserModalOpened] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ["departmentUsers", orgId, departmentName],
    queryFn: () => getDepartmentUsers(orgId, departmentName),
    enabled: !!orgId && !!departmentName,
  });
  
  const handleAddUser = (userData) => {
    // Refresh the user list after adding a user
    refetch();
    setAddUserModalOpened(false);
  };

  return (
    <>
      <Drawer
        opened={opened}
        onClose={onClose}
        title={<Title order={4}>Manage Users - {departmentName}</Title>}
        position="right"
        size="1200px"
        padding="lg"
      >
        <Stack gap="lg">
          <Flex justify="space-between" align="center" mb={"2rem"}>
            <Group gap="sm">
              <IconUsers size={20} />
              <Title order={5}>Department Users</Title>
            </Group>
            <Group>
              <TextInput
                placeholder="Search users..."
                icon={<IconSearch size={16} />}
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.currentTarget.value)}
                style={{ minWidth: 300 }}
              />
              <Button
                leftSection={<IconPlus size={18} />}
                onClick={() => setAddUserModalOpened(true)}
                variant="filled"
              >
                Add User
              </Button>
            </Group>
          </Flex>

          <UsersTable
            data={data}
            isLoading={isLoading}
            isError={isError}
            departmentId={departmentId}
            departmentName={departmentName}
            orgId={orgId}
            searchQuery={searchQuery}
            onSearchChange={setSearchQuery}
          />
        </Stack>
      </Drawer>

      <AddUserModal
        opened={addUserModalOpened}
        onClose={() => setAddUserModalOpened(false)}
        onSubmit={handleAddUser}
        departmentName={departmentName}
      />
    </>
  );
};

export default UserManagementDrawer;
